export default "__VITE_ASSET__DKoAte9N__"